<template>
<div class="search">
  <user-list :users="users" @onRowClick="onRowClick"></user-list>
  <!-- <ticket-list></ticket-list> -->
</div>
  
</template>

<script>
import UserList from '@/components/list/User'
import TicketList from '@/components/list/Tickets'
import * as TYPES from '../store/types'
export default {
  props: ['search'],
  components: {
    UserList,
    TicketList
  },
  computed: {
    users() {
      return this.$store.state.users.list.items
    },
    list() {
      return this.$store.state.users.list
    }
  },
  mounted() {
    this.$store.dispatch(TYPES.DO_GET_USER_SEARCH, '')
  },
  methods: {
    onRowClick(item) {
      this.$store.dispatch(TYPES.ON_USER_VIEW, item)
      this.$router.push('/vip/' + item.phone)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Search.vue